export default __webpack_public_path__ + "static/media/people6full.860489a4.jpg";